module.exports = {"TXTWCL_Add_To_Bet_Slip_1":{"id":"TXTWCL_Add_To_Bet_Slip_1","defaultMessage":"Aggiungi alla schedina"}}